import { useMemo } from "react";
import { PendingProgressCard } from "./PendingProgressCard";

export interface PendingItem {
  id: string;
  createdAt: string;
}

interface PendingMediaPlaceholderProps {
  count: number;
  label: string;
  items: PendingItem[];
  mediaType: "image" | "video";
  completingIds?: Set<string>;
}

export function PendingMediaPlaceholder({
  count,
  items,
  mediaType,
  completingIds,
}: PendingMediaPlaceholderProps) {
  const remaining = Math.max(0, count - (items?.length ?? 0));
  const hasBoostSlots = remaining > 0;

  // Stable timestamp for optimistic boost slots — regenerates when
  // remaining transitions from 0 to >0 (i.e. a new generation starts).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const boostCreatedAt = useMemo(() => new Date().toISOString(), [hasBoostSlots]);

  if (count <= 0) return null;

  return (
    <>
      {items?.map((item) => (
        <PendingProgressCard
          key={item.id}
          createdAt={item.createdAt}
          mediaType={mediaType}
          isComplete={completingIds?.has(item.id)}
        />
      ))}
      {Array(remaining)
        .fill(null)
        .map((_, idx) => (
          <PendingProgressCard
            key={`pending-boost-${idx}`}
            createdAt={boostCreatedAt}
            mediaType={mediaType}
          />
        ))}
    </>
  );
}
